import { useQuery } from "@tanstack/react-query";
import { getCompanyInfo } from "@/api";
import { CompanyInfo } from "@/types";

export const useCompanyInfo = (companyId?: number) => {
  const query = useQuery<CompanyInfo>({
    queryKey: ["companyInfo", companyId],
    queryFn: () => getCompanyInfo(companyId!),
    staleTime: 1000 * 60 * 5,
    enabled: !!companyId,
  });

  return {
    ...query,
    data: query.data || null,
  }
};